module.exports = require("vue-echarts");